import React, {useEffect, useState} from 'react';
import {user_data} from "../../../../../../../../components/functions/usr";
import decade_days, {gmslar, season_month} from "../../../../../../../../components/sfr/maydon";
import axios from "axios";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import {header} from "../../../../../../../../components/api/Header";
import Info from "./Info";
import { getEnv } from "../../../../../../../../lib/env";

function Xisobot5(props) {
    const year = localStorage.getItem('sfr-hm-year')
    const user = user_data()
    const season = localStorage.getItem('sfr-hm-season')
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba?JSON.parse(manba):[]
    const crops1 = localStorage.getItem('sfr-hm-'+season+'-ekinids')
    const cropids = crops1?JSON.parse(crops1):[]
    const [swed, setSwed] = useState({})
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist?JSON.parse(ist):[]
    const [maydonlar, setMaydonlar] = useState({})
    const ekin = localStorage.getItem("sfr-hm-"+season+"-ekinlar")
    const ekinlar = ekin?JSON.parse(ekin):{}
    const sfrMaydon = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const sfrMaydonlar = sfrMaydon?JSON.parse(sfrMaydon):{}
    const daysindek = decade_days(season,year)
    const may = localStorage.getItem("sfr-hm-"+season+"-maydon")
    const maydon = may?JSON.parse(may):[]
    const [birlik,setBirlik] = useState(1000)
    useEffect(()=>{
        let gmss = []
        const fetchSwed = async (gmss,gmss2) => {
            const postData = {
                crops:cropids,
                gmss,
                maydonlar:gmss2
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/veg_sugorish_meyyori2",
                postData,
                header(),
            )
                .catch(e=>{
                    console.log("Xato",e)
                })
            if(res){
                setSwed(res.data)
            }
        }
        const maydons = () => {
            let gidromodullar = []
            istemolchilar.map(i=>{
                if(i.gms){
                    i.gms.map(g=>{
                        if(!gidromodullar.includes(g)){
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydons()
        const gmss2 = gmslar(maydon,cropids)
        setMaydonlar(gmss2)
        if(gmss2)
            fetchSwed(gmss,gmss2)
    },[])

    const ff = (ist,fik) => {
        if(!ist.gms) return 0
        if(!ist.gms.length) return 0
        let res = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        for(let deks = 1; deks < 19; deks++){
            let bm = 0
            let jbm = 0
            Object.keys(ekinlar).map(e=>{
                let nm = 0
                let jnm = 0

                if(swed[e.slice(1)]){
                    ist.gms.map(gms2=>{
                        if(swed[e.slice(1)][gms2]){
                            let jm = maydonlar['g'+gms2]?maydonlar['g'+gms2][e]:0
                            let im = sfrMaydonlar['i'+ist.id]?sfrMaydonlar['i'+ist.id]['g'+gms2]?sfrMaydonlar['i'+ist.id]['g'+gms2][e]:0:0
                            let ds = swed[e.slice(1)][gms2][deks] * 1/0.0864/daysindek['d'+deks]
                            let jds = swed[e.slice(1)][gms2][deks]
                            nm = addFunc(nm,(bolFunc(im,jm)*ds))
                            jnm = addFunc(jnm,(bolFunc(im,jm)*jds))
                        }
                    })
                    bm = addFunc(bm,bolFunc(nm,fik))
                    jbm = addFunc(jbm,bolFunc(jnm,fik))
                }
            })
            res[deks-1] = bm > 0 ? bm / birlik : 0
            res[18] = addFunc(res[18],jbm > 0 ? jbm / birlik  : 0)
        }
        return res
    }
    const xisobot = () => {
        if(manbalar.length){
            let obj = [];
            let tr = 1;
            let jm = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            manbalar.map((manba,i)=>{
                jm = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                let istemolchi = istemolchilar.filter(istemolchi=>istemolchi.mid == manba.id)
                if(istemolchi.length){
                    istemolchi.map(ist => {
                        let ms = ff(ist,manba.fik)
                        obj.push(
                            <tr key={ist.name+i+"a"}>
                                <td>{tr++}</td>
                                <td className="text-start">{ist.name}</td>
                                {
                                    ms.length?
                                        ms.map((m,mi)=>{
                                            jm[mi] = addFunc(jm[mi],m)
                                            return <td key={mi}>{m?fixIt(m,3):''}</td>
                                        })
                                        :null
                                }
                            </tr>
                        )
                    })
                }

                obj.push(
                    <tr key={i+"b"}>
                        <th colSpan={2} className="text-start">Jami {manba.name} bo'yicha</th>
                        {
                            jm.map((j,ji)=>{
                                return <th key={ji}>{j?fixIt(j,3):''}</th>
                            })
                        }
                    </tr>
                )

            })

            return obj;
        }
    }

    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-borderless m-0">
                    <thead>
                    <tr>
                        <td><h4 className="text-center">Xisobot - №3</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 className="text-center px-5">{user.district}ning {year} yil sug'orish davrida suv olish JADVALI</h5>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-3">
                    <select className="form-select ms-auto" style={{maxWidth:"max-content"}} onChange={e=>{setBirlik(parseInt(e.target.value))}}>
                        <option value="1000">m<sup>3</sup>/sek</option>
                        <option value="1">l/sek</option>
                    </select>
                </div>
                <div className="flex-box xisobot-table">
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background:"#77adba",color:"#fff"}}>
                            <tr>
                                <th rowSpan={2}>No</th>
                                <th rowSpan={2}>Suv istemolchilari</th>
                                {
                                    season_month(season).map((m,i)=>{
                                        return <th key={i} colSpan={3}>{m}</th>
                                    })
                                }
                                <th rowSpan={2}>Jami mln.m<sup>3</sup></th>
                            </tr>
                            <tr>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                                <th>I</th>
                                <th>II</th>
                                <th>III</th>
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-2">
                <Info />
            </div>
        </div>
    );
}

export default Xisobot5;